<template>
    <toolbar-option type="stacked" :message="message">
        <template slot="primary">
            <input
                type="text"
                :value="numCharacters"
                placeholder="Enter a number"
                @input="onInput"
            >
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

const CUSTOM_ATTR_NAME = 'max-characters';

export default {
    name: 'max-characters',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Max Characters',
            message: '* All characters after the maximum count will be removed, and replaced with an ellipses',
            numCharacters: null,
        };
    },

    methods: {
        onInput(e) {
            this.numCharacters = e.target.value;

            if (this.numCharacters) {
                this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.numCharacters);
            } else {
                this.selectedElements[0].removeElementData(CUSTOM_ATTR_NAME);
            }

            this.onOptionChange(this.numCharacters);
        },

        onSelectedElement() {
            this.numCharacters = this.selectedElements[0].getElementData(CUSTOM_ATTR_NAME);
        },
    },
};
</script>
